import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { ENV_CONFIG } from '@sc/data-access-environment';
import {
  CallableScript,
  Environment,
  MetaInjection,
  RoutingName,
} from '@sc/data-access-models';

@Injectable({
  providedIn: 'root',
})
export class ScriptManagerService {
  constructor(
    private readonly configService: ConfigurationService,
    @Inject(ENV_CONFIG) private readonly env: Environment,
    @Inject(DOCUMENT) private readonly doc: Document
  ) {}

  callScripts(scriptIds: string[] = []) {
    const allAskedScripts =
      this.configService
        .getConfig()
        .htmlDomOptions?.callableScripts?.filter(
          (script) =>
            scriptIds.includes(script.id) &&
            script.env.includes(this.env.envName)
        ) || [];

    allAskedScripts.forEach((script) => this.addScriptToHead(script));
  }

  injectMetaTag(pageName: RoutingName) {
    const metaTags =
      this.configService
        .getConfig()
        ?.htmlDomOptions?.metaInjection?.filter(
          (tag) =>
            tag?.pages?.includes(pageName) &&
            tag?.env?.includes(this.env.envName)
        ) || [];

    metaTags?.forEach((tag) => this.addMetaTag(tag));
  }

  private addScriptToHead(script: CallableScript) {
    const scriptTag = this.doc.createElement('script');

    scriptTag.src = script.url;
    scriptTag.async = true;

    this.doc.head.appendChild(scriptTag);
  }

  private addMetaTag(tag: MetaInjection) {
    const metaTag = this.doc.createElement('meta');
    metaTag.name = tag?.name;
    metaTag.content = tag?.content;
    if (tag?.title) {
      metaTag.title = tag?.title;
    }

    const existingTag = this.doc.head.querySelector(`[name=${tag?.name}]`);
    if (!existingTag) {
      this.doc.head.appendChild(metaTag);
    }
  }
}
